import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listChaosKey2") };
export const campListSave  = (params) => { return req("post", "/customer/addChaosKey2", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteChaosKey2", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG14.js